var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { ImageDimensions } from './modules/ImageDimensions';
import { memoize } from '../../../utils/mobx/decorators/memoize';
import { ImageImg } from './modules/ImageImg';
import { AttachedContent } from '../../trait/attachedcontent/AttachedContent';
import { runtime } from '../../runtime/Runtime';
import { ImageThumb } from './modules/ImageThumb';
import { strip } from '../../../utils/serializr/schema/inner/strip';
export class AttachedImage extends AttachedContent {
    type = 'image';
    get imageImg() {
        return new ImageImg(this);
    }
    get imageDimensions() {
        return new ImageDimensions(this);
    }
    get imageThumb() {
        return new ImageThumb(this);
    }
    get imageEdit() {
        return new runtime.solidPackages.Edit.classes.ImageEdit(this);
    }
    get img() {
        return this.imageImg.img;
    }
    get localImg() {
        return this.imageImg.localImg;
    }
    static get stripInfo() {
        return {
            extends: AttachedContent.stripInfo,
            props: {
                image: strip((at) => at.img.serialized),
            },
        };
    }
}
__decorate([
    memoize
], AttachedImage.prototype, "imageImg", null);
__decorate([
    memoize
], AttachedImage.prototype, "imageDimensions", null);
__decorate([
    memoize
], AttachedImage.prototype, "imageThumb", null);
__decorate([
    memoize
], AttachedImage.prototype, "imageEdit", null);
__decorate([
    memoize
], AttachedImage, "stripInfo", null);
